/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/call-end";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "CallEnd";
export { I as CallEnd };
